import { globalState } from '@codeleap/store'

import { Credential, ProviderId } from '@/features/Auth/providers/types'

export type PendingLink = {
  provider: ProviderId
  credential: Credential
}

/**
 * A credential held back because its address already belongs to another provider.
 *
 * Firebase refuses `signInWithCredential` with
 * `auth/account-exists-with-different-credential` when someone signs in with, say, Facebook
 * using an address already registered through Google. The credential is still good — it just
 * cannot create a second account — so it is kept until that person signs in the way they
 * already can, and then attached to the account they were always going to reach.
 *
 * Outside the machine's own state on purpose: it has to survive the failure that produced it
 * and the reset that follows, and be redeemed by a later, separate sign-in. See EPIC-005.
 */
const store = globalState<{ pending: PendingLink | null }>({ pending: null })

export const pendingLink = {
  get: () => store.get().pending,
  hold: (link: PendingLink) => store.set({ pending: link }),
  clear: () => store.set({ pending: null })
}
